import { FC, HTMLAttributes } from 'react';

export const PageHeading: FC<HTMLAttributes<HTMLHeadingElement>> = ({ className, children, ...props }) => (
  <>
    <h1 className={` text-center text-xl font-bold md:text-left md:text-4xl ${className}`} {...props}>
      {children}
    </h1>

    <hr className="my-8 " />
  </>
);
